import { LinkedItemSon, SceneObjects } from '@types'

export default function isLinkedSon(linkedSon?: SceneObjects): linkedSon is LinkedItemSon {
  return Boolean(linkedSon) && linkedSon?.type === 'linkedSon'
}
